import common from './common'
import download from './download'
import email from './email'
import eventSettings from './eventSettings'
import eventinfo from './eventinfo'
import exhibitors from './exhibitors'
import files from './files'
import home from './home'
import leads from './leads'
import login from './login'
import password from './password'
import questions from './questions'

const translations = {
  common,
  download,
  email,
  eventinfo,
  exhibitors,
  files,
  home,
  login,
  password,
  questions,
  leads,
  eventSettings
}

export default translations
